import {CALL_API} from '../../middleware/api';

// 待领任务

export const TASK_CANDIDATE_REQUEST = 'TASK_CANDIDATE_REQUEST';
export const TASK_CANDIDATE_SUCCESS = 'TASK_CANDIDATE_SUCCESS';
export const TASK_CANDIDATE_FAILURE = 'TASK_CANDIDATE_FAILURE';

// page=1
export function getCandidateTask ({page, size}) {
	return {
		[CALL_API]: {
			types: [TASK_CANDIDATE_REQUEST, TASK_CANDIDATE_SUCCESS, TASK_CANDIDATE_FAILURE],
			endpoint: `/workflow/task/candidate?page=${page}&size=${size}`
		}
};
}

export default (params) => {
	return (dispatch, getState) => {
		return dispatch(getCandidateTask(params));
	};
};


// WEBPACK FOOTER //
// ./src/action/workflow/candidate.js